import MetaService from 'services/MetaService';

export async function fetchSystemData() {
  const result = await MetaService.getServiceInfo();
  return result;
}
